module.exports = __webpack_public_path__ + "static/img/1_7.2f326407.jpg";